import {
    Accordion,
    AccordionContent,
    AccordionItem,
    AccordionTrigger,
} from "../ui/accordion";
import { Reveal, SectionHeader } from "./Reveal";

const FAQS = [
    {
        q: "O tratamento de canal dói?",
        a: "O objetivo do atendimento é justamente controlar o desconforto. São utilizadas técnicas anestésicas e recursos clínicos voltados ao conforto, adaptados às necessidades de cada paciente. A experiência pode variar conforme o caso e é avaliada individualmente.",
    },
    {
        q: "Quantas sessões são necessárias?",
        a: "O número de sessões depende das características de cada caso, como a condição do dente e a complexidade do tratamento. Após a avaliação inicial, o Dr. Gabriel apresenta o planejamento mais adequado para você.",
    },
    {
        q: "O que é a microscopia operatória?",
        a: "É um equipamento que amplia e ilumina o campo de trabalho, auxiliando o especialista na visualização de detalhes e estruturas internas do dente. Esse recurso contribui para a precisão dos procedimentos endodônticos.",
    },
    {
        q: "Quando o retratamento de canal é indicado?",
        a: "O retratamento pode ser indicado quando um dente já tratado apresenta alterações que merecem reavaliação. A indicação só é feita após análise clínica e de imagens, considerando a possibilidade de preservação do dente.",
    },
    {
        q: "Como agendar uma consulta?",
        a: "Basta chamar no WhatsApp (13) 99788-1908. Você pode usar qualquer botão de agendamento desta página — a mensagem já vai pré-preenchida para agilizar o atendimento.",
    },
];

export const Faq = () => (
    <section id="faq" data-testid="faq-section" className="bg-[#FAFCFF] py-24 md:py-32">
        <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:px-8">
            <SectionHeader
                center
                overline="Dúvidas frequentes"
                title="Perguntas sobre o tratamento de canal"
                subtitle="Respostas diretas para as dúvidas mais comuns antes da consulta."
            />
            <Reveal delay={0.15}>
                <Accordion type="single" collapsible className="mt-12 space-y-4">
                    {FAQS.map((item, i) => (
                        <AccordionItem
                            key={item.q}
                            value={`item-${i}`}
                            data-testid={`faq-item-${i}`}
                            className="rounded-2xl border border-slate-200/80 bg-white px-6 shadow-sm transition-colors data-[state=open]:border-[#BFDBFE]"
                        >
                            <AccordionTrigger
                                data-testid={`faq-trigger-${i}`}
                                className="py-5 text-left font-heading text-base font-semibold text-slate-900 hover:text-[#1A6AFF] hover:no-underline"
                            >
                                {item.q}
                            </AccordionTrigger>
                            <AccordionContent
                                data-testid={`faq-content-${i}`}
                                className="pb-5 text-sm leading-relaxed text-slate-600"
                            >
                                {item.a}
                            </AccordionContent>
                        </AccordionItem>
                    ))}
                </Accordion>
            </Reveal>
        </div>
    </section>
);
